import {useSelector} from 'react-redux'
import './index.scss'
import classNames from 'classnames'

const Badge = ({children, color, className, size = null, title}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <span
            title={title}
            className={classNames({
                'badge': true,
                [`badge-${color}`]: color,
                [`badge-${size}`]: size,
                [className]: className,
                'dark': isDarkMode
            })}>{children}</span>
    )
}

export default Badge
